import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DraggableDialogPaperComponent from '../../common/components/DraggableDialogPaperComponent';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import _ from 'lodash';
import { Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import { TextField } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { Editor } from '@tinymce/tinymce-react';
import TestParserOutputDialog from './TestParserOutputDialog'
import { CircularProgress } from '@material-ui/core';

class TestParserDialog extends Component {
  state = observable({
    open: true,
    email: {
      subject: "",
      body: {
        text: "",
        html: ""
      },
      from: "",
      to: ""
    },
    parsedData: null,
    parserId: null,
    isLoading: true,
    isTestParserApiLoading: false
  })

  componentDidMount() {

  }

  handleTestParser = () => {
    let emailData = this.state.email;

    if (this.state.isTestParserApiLoading) {
      return;
    }
    this.state.isTestParserApiLoading = true;

    window.TL.ApiClient.MailParser.testParser(
      {
        subject: emailData.subject,
        body: JSON.stringify(emailData.body),
        from: emailData.from,
        to: emailData.to,
        mail_inbox_account_id: this.props.mailInboxAccountId,
        parser_id: this.props.parserId
      }).then({
        success: (response) => {
          this.state.isTestParserApiLoading = false;
          if (!response.success) {
            Ext.Msg.alert('Error', response.messages);
            return;
          }
          this.state.parsedData = response.data;
        }
      })
  }

  handleChange = (type, ev) => {
    this.state.email[type] = type == "body"
      ? {
        html: ev.target.getContent(),
        text: ev.target.getContent({
          format: "text"
        })
      }
      : ev.target.value;
  }

  render() {
    const props = this.props,
      { store } = props,
      row = {};


    return (
      <Dialog
        open={this.state.open}
        // onClose={handleClose}
        PaperComponent={DraggableDialogPaperComponent}
        aria-labelledby="draggable-dialog-title"
        maxWidth={"md"}
        fullWidth={true}
      >

        <DialogContent >
          <Typography variant="h6">Test Parser</Typography>
          {props.isFromShown && <TextField
            placeholder="paste from email"
            fullWidth
            value={this.state.email.from}
            onChange={this.handleChange.bind(this, "from")}
            margin="normal"
            variant="outlined"
          />}
          {props.isToShown && <TextField
            placeholder="paste to email"
            fullWidth
            value={this.state.email.to}
            onChange={this.handleChange.bind(this, "to")}
            margin="normal"
            variant="outlined"
          />}
          <TextField
            placeholder="paste subject"
            fullWidth
            value={this.state.email.subject}
            onChange={this.handleChange.bind(this, "subject")}
            margin="normal"
            variant="outlined"
          />
          {this.state.isLoading && <CircularProgress disableShrink />}
          <Editor
            initialValue="<p>paste body</p>"
            apiKey="qnjxik5m7hnatzahksumpbi3v9a6oxgfcc22fyjovjh62zps"
            init={{
              height: 500,
              menubar: false,
              entity_encoding: "named",
              custom_elements: "~column",
              // cleanup_on_startup: false,
              // trim_span_elements: false,
              // verify_html: false,
              // cleanup: false,
              // convert_urls: false,
              plugins: [
                'advlist autolink lists link image charmap print preview anchor',
                'searchreplace visualblocks code fullscreen',
                'insertdatetime media paste code help wordcount'
              ],
              toolbar: "",
              content_style: '* { font-size: 12px; }',
              setup: (ed) => {
                ed.on('init', (args) => {
                  this.state.isLoading = false;
                });
              }
              // setup: function (ed) {
              //   ed.on('init', function () {
              //     // this.execCommand("fontName", false, "tahoma");
              //     this.execCommand("fontSize", false, "12px");
              //   });
              // }
              // init_instance_callback: function (editor) {
              //   editor.on('NodeChange', function (e) {
              //     console.log('Node changed', e);
              //   });
              // }
            }}
            onChange={this.handleChange.bind(this, "body")}
          />

          {this.state.parsedData &&
            <TestParserOutputDialog
              open={this.state.parsedData}
              values={this.state.parsedData.rows}
              parserId={this.state.parsedData.parser_id}
              onClose={() => this.state.parsedData = null}
            />
          }
        </DialogContent>
        <DialogActions>

          <Button onClick={() => { this.state.open = false; }} color="primary">
            Close
            </Button>
          <Button onClick={this.handleTestParser} color="primary">
            {!this.state.isTestParserApiLoading ? "Test" : <CircularProgress />}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default observer(TestParserDialog);
